import { frontendURL } from '../../../helper/URLHelper';

const RecurringMessagesView = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/recurring-messages'),
    name: 'recurring_messages_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: RecurringMessagesView,
  },
];
